import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import MainContent from '../../MainContent'
import { BoxCenter } from '../../../generic/Box'
import Column from '../../../generic/Column'
import Columns from '../../../generic/Columns'
import BranchList from './BranchList'
import XmlSearch from './XmlSearch'
import NFEDashboard from './NFEDashboard'
import CompanyList from '../CompanyList'
import EnvironmentList from '../EnvironmentList'
import NFECertDate from './NFECertDate'

const NFEPage = inject('userStore', 'nfeStore')(observer(
  class NFEPage extends Component {
    constructor (props) {
      super(props)
      const { userStore, nfeStore } = this.props
      const sortedCompanies = userStore.state.companies.sort((current, next) => current.name.localeCompare(next.name))
      nfeStore.setCompany(sortedCompanies[0].id)
      nfeStore.fetchFiles()
    }

    render () {
      const { userStore, nfeStore } = this.props
      if (!userStore.checkPermission('4nfe_view')) {
        return <NoPermission />
      }
      const content = nfeStore.state.branch ? <NFEDashboard /> : null
      return (
        <MainContent>
          <Columns>
            <Column>
              <CompanyList permission='4nfe_change_company' formStore={nfeStore} />
            </Column>
            <Column>
              <BranchList />
            </Column>
            <Column>
              <EnvironmentList formStore={nfeStore} />
            </Column>
          </Columns>
          <Columns>
            <Column>
              <XmlSearch />
            </Column>
            <Column>
              <NFECertDate />
            </Column>
          </Columns>
          { content }
        </MainContent>
      )
    }
  }
))

const NoPermission = props => {
  return (
    <MainContent>
      <Columns>
        <Column className='is-6'>
          <BoxCenter>
            Conheça a Nfe
          </BoxCenter>
        </Column>
      </Columns>
    </MainContent>
  )
}

export default NFEPage



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4nfe/NFEPage.js